import React from 'react';
import { Mail, Heart } from 'lucide-react';
import { motion } from 'framer-motion';
import ScrollToTopLink from './ScrollToTopLink';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-stone-800">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand & Description */}
          <div className="space-y-4">
            <motion.div
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              <ScrollToTopLink to="/" className="inline-block">
                <img
                  src="/letshost-logo-white.png"
                  alt="LetsHost"
                  className="h-9"
                />
              </ScrollToTopLink>
            </motion.div>
            <p className="text-base text-stone-400 max-w-xs leading-relaxed">
              NYC's premier venue concierge. Connecting hosts with the perfect space for every occasion.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3
              className="text-sm font-semibold tracking-wider uppercase text-stone-500 mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Quick Links
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/mission', label: 'Mission' },
                { to: '/venues', label: 'Venues' },
                { to: '/guides', label: 'Guides' },
                { to: '/inspo', label: 'Inspo' },
                { to: '/calculator', label: 'Calculator' },
                { to: '/', label: 'Plan Your Event' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <ScrollToTopLink
                    to={to}
                    className="text-base text-stone-400 hover:text-white transition-colors"
                  >
                    {label}
                  </ScrollToTopLink>
                </li>
              ))}
              <li>
                <ScrollToTopLink
                  to="/privacy"
                  className="text-base text-stone-500 hover:text-white transition-colors"
                >
                  Privacy Policy
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  to="/terms"
                  className="text-base text-stone-500 hover:text-white transition-colors"
                >
                  Terms & Conditions
                </ScrollToTopLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3
              className="text-sm font-semibold tracking-wider uppercase text-stone-500 mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Contact
            </h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:events@letshost.nyc"
                  className="text-base text-stone-400 hover:text-white transition-colors flex items-center group"
                >
                  <Mail className="h-5 w-5 mr-3 text-stone-600 group-hover:text-stone-400 transition-colors" />
                  events@letshost.nyc
                </a>
              </li>
              <li className="pt-2">
                <p className="text-sm text-stone-500">
                  New York City
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-6 border-t border-stone-800">
          <p className="text-sm text-stone-500 text-center flex items-center justify-center">
            <span>© {currentYear} LetsHost. All rights reserved.</span>
            <span className="mx-2 text-stone-700">•</span>
            <span className="flex items-center">
              Made with <Heart className="h-3 w-3 mx-1 text-rose-400" /> in NYC
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
} 